import React from 'react';

import { Meta } from '@www/components/Meta';
import { MEETBUTTER_BUTTER_URL } from 'utils/const/links';

import { RedirectScreen } from 'screens/RedirectScreen';
import { useRouter } from 'next/router';

const Home = () => {
  const { asPath } = useRouter();

  return (
    <div>
      <Meta />

      <RedirectScreen url={`${MEETBUTTER_BUTTER_URL}${asPath}`} />
    </div>
  );
};

export default Home;
